import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import {dataTestId} from '@hconnect/uikit'
import {Stack, Typography} from '@mui/material'
import {LockOutlined} from '@mui/icons-material'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PlannerSwitch} from '../../../../../../shared/components/formComponents/PlannerSwitch'
import {useCurrentTimeRounded} from '../../../../../../shared/hooks/useCurrentTimeRounded'
import {usePlantConfig} from '../../../../../../shared/hooks/usePlantConfigData'
import {ScheduleItem} from '../../../../../../shared/interfaces/api'

interface ScheduleItemFixedForOptimizerSwitchProps {
  scheduleItem: ScheduleItem
  handleShutdownAvailabilityChange: (isShutdownAvailable: boolean) => void
}
export const ScheduleItemFixedForOptimizerSwitch: React.FC<
  ScheduleItemFixedForOptimizerSwitchProps
> = ({scheduleItem, handleShutdownAvailabilityChange}) => {
  const {t} = useTranslation()
  const {timezone_id: timezoneId} = usePlantConfig()
  const nowRounded = useCurrentTimeRounded({timezoneId, roundingFn: roundTo15MinIntervalStart})
  const isDisabled = moment.utc(scheduleItem.end).isBefore(nowRounded)

  const onChange = (isChecked: boolean) => handleShutdownAvailabilityChange(isChecked)

  return (
    <PlannerSwitch
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <LockOutlined />
          <Typography>{t('planning.markAsFixedForOptimizer')}</Typography>
        </Stack>
      }
      value={scheduleItem.isFixed}
      onChange={onChange}
      disabled={isDisabled}
      {...dataTestId('is_fixed_switch')}
    />
  )
}
